import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../../pages/BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../../pages/BookAppointment/queries/get-book-appointment-type.js';
import { useAppointmentTypes } from '../../pages/BookAppointment/hooks/use-appointment-types.js';
import AppointmentTypeList from './AppointmentTypeList.js';

const AppointmentTypeListContainer = (props)=>{
    const { appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , groupedAppointmentTypeToolTips , groupedAppointmentGlobalLabels ,  } = useAppointmentTypes();
    return /*#__PURE__*/ React.createElement(AppointmentTypeList, swcHelpers.extends({}, props, {
        appointmentTypeIcons: appointmentTypeIcons,
        appointmentTypeToolTips: appointmentTypeToolTips,
        appointmentGlobalLabels: appointmentGlobalLabels,
        groupedAppointmentTypeToolTips: groupedAppointmentTypeToolTips,
        groupedAppointmentGlobalLabels: groupedAppointmentGlobalLabels
    }));
};

export { AppointmentTypeListContainer as default };
//# sourceMappingURL=AppointmentTypeListContainer.js.map
